import { getStatus, isStatus } from '@/utils'
import { RECONCILIATION_STATUSES } from '../constants'
import type { ReconciliationStatus, ReconciliationStatusKey } from '../stores'

// Both a statement (rolled-up) and a single cycle carry a reconciliationStatus.
interface Reconcilable {
  reconciliationStatus?: ReconciliationStatus
}

export const isReconciliationStatus = (
  record: Reconcilable | null | undefined,
  ...expectations: ReconciliationStatusKey[]
) =>
  isStatus(
    RECONCILIATION_STATUSES,
    record,
    'reconciliationStatus',
    ...expectations,
  )

export const isReconciled = (record: Reconcilable) =>
  isReconciliationStatus(record, 'reconciled')

export const needsReview = (record: Reconcilable) =>
  isReconciliationStatus(record, 'needsReview')

export const isUnverifiable = (record: Reconcilable) =>
  isReconciliationStatus(record, 'unverifiable')

// Some of the statement's cycles passed the reconcile and some were never checked at all.
export const isPartiallyReconciled = (record: Reconcilable) =>
  isReconciliationStatus(record, 'partiallyReconciled')

// "unknown" = a statement processed before reconciliation existed (or not yet reprocessed).
export const isNotChecked = (record: Reconcilable) =>
  isReconciliationStatus(record, 'unknown')

export const getReconciliationStatus = (value: ReconciliationStatus) =>
  getStatus(RECONCILIATION_STATUSES, value)
